import React from 'react';
import { PartStatusEnum } from '../../models-enums';
import { IWorkOrder } from '../../models';

const PartsIcon = ({ partStatus, parts }: { partStatus: IWorkOrder['partStatus']; parts: IWorkOrder['parts'] }) => {
    // no workorder associated
    if (partStatus === undefined) {
        return <span className="part-status hollow-green" />;
    }

    // explicitly no parts
    if (partStatus === PartStatusEnum.None && parts?.length === 0) {
        return <span className="part-status hollow-green" />;
    }

    if (partStatus === PartStatusEnum.Delivered || partStatus === PartStatusEnum.None) {
        return <span className="part-status green" />;
    } else if (partStatus === PartStatusEnum.Shipped) {
        return <span className="part-status yellow" />;
    } else if (partStatus === PartStatusEnum.Ordered) {
        return <span className="part-status red" />;
    }

    return null;
};

export default PartsIcon;
